module.exports = __webpack_public_path__ + "static/seinfeld-8007f2bc16a3ebf15e43756b5d81344d.jpg";